import './Testimonials.css';

const featured = {
  name: 'Sophie M.',
  role: 'Maman de Lucas, 8 ans',
  initials: 'SM',
  stars: 5,
  highlight: '3 semaines pour changer nos matins',
  quote: 'Depuis Evolify, Lucas range sa chambre sans qu\'on lui demande. J\'avais du mal à y croire. Le déclic ? Il a lui-même choisi ses tâches et son avatar dragon. En 3 semaines, nos matins sont passés de tension permanente à… sérénité. C\'est la meilleure chose qu\'on ait faite cette année.',
  badge: '⭐ Coup de cœur bêta',
};

const testimonials = [
  {
    name: 'Thomas P.',
    role: 'Papa de Camille et Léo, 6 et 9 ans',
    initials: 'TP',
    color: '#10B981',
    stars: 5,
    quote: 'Le matin était une guerre. Maintenant mes deux enfants font leur routine et arrivent à table tout seuls. Les petits messages d\'Evo à chaque validation, c\'est magique — Léo nous appelle juste pour nous montrer qu\'il a gagné des XP.',
  },
  {
    name: 'Marie-Claire D.',
    role: 'Maman de Théo, 7 ans',
    initials: 'MC',
    color: '#EC4899',
    stars: 5,
    quote: 'J\'étais sceptique — encore une appli ? Mais là c\'est différent : c\'est l\'enfant qui est acteur. Théo est tellement fier quand il monte de niveau. Et moi j\'ai enfin arrêté de répéter les mêmes choses 10 fois.',
  },
  {
    name: 'Antoine R.',
    role: 'Papa de Juliette, 10 ans',
    initials: 'AR',
    color: '#F59E0B',
    stars: 5,
    quote: 'On a activé le Mode Autonomie progressivement comme conseillé. En 2 mois, Juliette fait ses devoirs seule, sans récompense. C\'est exactement ce qu\'on cherchait depuis des années : une vraie autonomie, pas juste de l\'obéissance.',
  },
  {
    name: 'Nathalie B.',
    role: 'Maman de Mathis et Zoé, 7 et 11 ans',
    initials: 'NB',
    color: '#F97316',
    stars: 5,
    quote: '15 minutes pour créer les tâches avec les enfants, et depuis c\'est automatique. Mathis et Zoé se font même la "concurrence" de progression — ils s\'encouragent mutuellement. Je n\'aurais jamais imaginé ça il y a 6 mois.',
  },
];

function Stars({ count }) {
  return (
    <div className="testi-stars" aria-label={`${count} étoiles sur 5`}>
      {Array.from({ length: 5 }, (_, i) => (
        <span key={i} className={i < count ? 'testi-star testi-star--filled' : 'testi-star'}>★</span>
      ))}
    </div>
  );
}

function Avatar({ initials }) {
  return (
    <div className="testi-avatar">
      {initials}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="testimonials" id="temoignages">
      <div className="testimonials__bg">
        <div className="testimonials__bg-blob--1" />
        <div className="testimonials__bg-blob--2" />
      </div>

      <div className="container">
        <div className="testimonials__header">
          <div className="section-label">💬 Témoignages</div>
          <h2 className="section-title">Des familles qui ont franchi le pas</h2>
          <p className="section-subtitle">
            Plus de 200 familles testent Evolify en bêta. Voici ce qu'elles vivent au quotidien.
          </p>
        </div>

        {/* Featured — grand card coloré */}
        <div className="testi-featured">
          <div className="testi-featured__deco">"</div>
          <div className="testi-featured__top">
            <span className="testi-featured__badge">{featured.badge}</span>
            <Stars count={featured.stars} />
          </div>
          <blockquote className="testi-featured__quote">{featured.quote}</blockquote>
          <div className="testi-featured__highlight">
            <span>✨</span>
            {featured.highlight}
          </div>
          <div className="testi-featured__author">
            <Avatar initials={featured.initials} />
            <div className="testi-featured__author-info">
              <strong>{featured.name}</strong>
              <span>{featured.role}</span>
            </div>
          </div>
        </div>

        {/* Grille 2×2 colorée */}
        <div className="testimonials__grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testi-card" style={{ '--testi-color': t.color }}>
              <div className="testi-card__top">
                <Stars count={t.stars} />
                <div className="testi-card__verified">✓ Vérifié</div>
              </div>
              <blockquote className="testi-card__quote">"{t.quote}"</blockquote>
              <div className="testi-card__author">
                <Avatar initials={t.initials} />
                <div>
                  <strong className="testi-card__name">{t.name}</strong>
                  <span className="testi-card__role">{t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Barre de note */}
        <div className="testimonials__bar">
          <div className="testimonials__bar-rating">
            <span className="testimonials__bar-score" data-countup="4.9" data-decimal="1">4,9</span>
            <div>
              <Stars count={5} />
              <span className="testimonials__bar-label">Note moyenne sur 200+ familles bêta</span>
            </div>
          </div>
          <div className="testimonials__bar-divider" />
          <div className="testimonials__bar-stats">
            <div className="testimonials__bar-stat">
              <span>🏠</span>
              <strong data-countup="200" data-suffix="+">200+</strong>
              <span>familles actives</span>
            </div>
            <div className="testimonials__bar-stat">
              <span>📅</span>
              <strong data-countup="3" data-suffix=" sem.">3 sem.</strong>
              <span>pour voir des résultats</span>
            </div>
            <div className="testimonials__bar-stat">
              <span>💚</span>
              <strong data-countup="94" data-suffix="%">94%</strong>
              <span>recommandent</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
